import { silent } from './AbTestWrapper';
import BaseModal from '../../components/modals/BaseModal';
import { AbExperimentUI } from './AbExperimentUI';
import { AbTest } from './AbTest';
import AbTestHttpService from 'abTests/AbTestHttpService';

export default function AddAbExperimentsModal() {
    // silent for prod env, only allow modal on local|test-www|stage|shadow
    if (silent) return;
    // ready the ui tool modal
    new AbExperimentsModal();
}

const AA_BASE_URL = '/account';
const AA_BASE_XHR_URL = `${AA_BASE_URL}/xhr`;

const DASHBOARD_URL = '/experiments-dashboard/';
const DASHBOARD_XHR_URL = `${DASHBOARD_URL}xhr/get-variants-for-all-experiments/`;
const UI_TOOL_XHR_URL = `${DASHBOARD_URL}xhr/get-variants-for-experiments/`;

export const isAA = function () {
    let loc = document.location.pathname;
    const regex = new RegExp(/\/[a-z]{2}\/$/);
    return (
        loc === '/' ||
        regex.test(loc) ||
        loc.indexOf('/account') !== -1 ||
        loc.indexOf('/gift') !== -1
    );
};

const getDashbarodUrl = function () {
    return (isAA() ? AA_BASE_URL : '') + DASHBOARD_URL;
};

const getDashboardXhrUrl = function () {
    return (isAA() ? AA_BASE_XHR_URL : '') + DASHBOARD_XHR_URL;
};

const getUiToolXhrUrl = function () {
    return (isAA() ? AA_BASE_XHR_URL : '') + UI_TOOL_XHR_URL;
};

class AbExperimentsModal {
    constructor() {
        this.modalSelector = '.modal__container';
        this.abtestListSelector = '#abtest__list';
        this.modalCloseSelector = '.button__close';
        this.dashboardSelector = '#abtest-uiTool-dashboard';
        this.cssLinkId = 'uiToolCss';
        this.shiftCount = 0;
        this.shiftTimeout = 500;
        this.modal = null;
        this.modules = CBS?.AbTestsConfigs?.modules ?? {};
        this.pageAbTests = {}; //CBS.AbTestsConfigs?.modules ?? {};
        this.getDashboardXhrUrl = getDashboardXhrUrl;
        this.getUiToolXhrUrl = getUiToolXhrUrl;
        this.addModalKeyboardListener();
        this.autoLoadDashboard();
    }

    loadABTestUiToolCss() {
        const cssPath = CBS?.AbTestsConfigs?.uiTool;
        const cssLink = document.querySelector('#' + this.cssLinkId);
        if (cssPath && !cssLink) {
            let el = document.createElement('link');
            el.setAttribute('rel', 'stylesheet');
            el.setAttribute('type', 'text/css');
            el.setAttribute('href', cssPath);
            el.setAttribute('id', this.cssLinkId);
            document.querySelector('head').appendChild(el);
        }
    }

    removeABTestUiToolCss() {
        const cssLink = document.querySelector('#' + this.cssLinkId);
        if (cssLink) {
            cssLink.remove();
        }
    }

    addModalKeyboardListener() {
        document.addEventListener('keydown', (event) => {
            if (event.key === 'Shift' && document.activeElement.tagName !== 'INPUT') {
                this.shiftCount++;
                setTimeout(() => {
                    this.shiftCount = 0;
                }, this.shiftTimeout);
                if (this.shiftCount === 2) {
                    this.showModal();
                    this.shiftCount = 0;
                }
            }
            if (event.key === 'Escape') {
                if (this.modal) {
                    this.modal.close();
                }
            }
        });
    }

    addTemplateListeners() {
        this.closeButtons = this.modal.me.querySelectorAll(this.modalCloseSelector);
        if (this.closeButtons) {
            this.closeButtons.forEach((el) => {
                el.addEventListener('click', (event) => {
                    try {
                        this.removeABTestUiToolCss();
                        this.modal.close();
                    } catch (e) {
                        // do nothing
                    }
                });
            });
        }
    }

    showModal() {
        if (document.querySelector(this.modalSelector)) return;
        this.modal = new BaseModal(AB_EXPERIMENTS_MODAL_TEMPLATE);
        this.modal.show();
        this.getPageExperiments()
            .then((res) => {
                this.pageAbTests = res.result;
                this.afterShowModal();
            })
            .catch((err) => {
                console.error(err);
            });
    }

    afterShowModal() {
        this.loadABTestUiToolCss();
        document.querySelector('.ui-tool').remove();
        this.populateTemplate();
        this.addTemplateListeners();
    }

    populateTemplate() {
        let seenActive = false;
        this.abTestListElement = this.modal.me.querySelector(this.abtestListSelector);
        if (Object.keys(this.pageAbTests).length) {
            if (this.abTestListElement) {
                Object.keys(this.pageAbTests)
                    .sort((a, b) => {
                        const experimentA = this.pageAbTests[a];
                        const experimentB = this.pageAbTests[b];

                        const nameA = experimentA.name?.toLowerCase() ?? '';
                        const nameB = experimentB.name?.toLowerCase() ?? '';

                        const isActiveA = experimentA.isActive;
                        const isActiveB = experimentB.isActive;

                        function sortByName(nameA, nameB) {
                            if (nameA < nameB) {
                                return -1;
                            } else if (nameA > nameB) {
                                return 1;
                            } else {
                                return 0;
                            }
                        }

                        if (isActiveA && isActiveB) {
                            return sortByName(nameA, nameB);
                        }

                        if (isActiveA && !isActiveB) {
                            return -1;
                        }

                        if (!isActiveA && !isActiveB) {
                            return sortByName(nameA, nameB);
                        }

                        return 0;
                    })
                    .map((abTestKey) => {
                        const experiment = this.pageAbTests[abTestKey];
                        new AbExperimentUI(new AbTest(experiment), this.abTestListElement);
                    });
            }
        }
    }

    // auto load for dashboard
    autoLoadDashboard() {
        const dashboard = document.querySelector(this.dashboardSelector);
        if (dashboard) {
            this.modal = new BaseModal(AB_EXPERIMENTS_MODAL_TEMPLATE);
            this.modal.me = document.createElement('div');
            this.modal.me.innerHTML = this.modal.template;
            dashboard.appendChild(this.modal.me);

            // hide container while data is pulled
            document.querySelector('.modal__container').classList.add('hide');
            document.querySelector('.control__bar').remove();
            document.querySelector('.modal__buttons').remove();

            // get variant data then populate the template and show it
            this.getAllExperiments()
                .then((res) => {
                    this.pageAbTests = res.result;
                    this.afterShowModal();

                    // show container
                    document.querySelector('.modal__container').classList.remove('hide');
                })
                .catch((err) => {
                    console.error('getAllExperiments error', err);
                });
        }
    }

    async getPageExperiments() {
        let pageHasXHRExperiment = false;
        let arr = [];
        Object.keys(this.modules).forEach((experiment) => {
            // determine if there are any xhr experiments
            // if there are, we need to fetch the variant
            if (!pageHasXHRExperiment) {
                pageHasXHRExperiment = this.modules[experiment].isXHR;
            }
            // push experiment for xhr request (if needed)
            arr.push(experiment);
        });

        // if there are any xhr experiments
        // we must fetch the variant for the user before rendering
        if (pageHasXHRExperiment) {
            const experiments = arr.join(',');
            let url = `${this.getUiToolXhrUrl()}?experiments=${experiments}`;
            return this.getExperiments(url);
        } else {
            // else just return the modules
            return {
                success: true,
                result: this.modules,
            };
        }
    }

    getAllExperiments() {
        return this.getExperiments(this.getDashboardXhrUrl());
    }

    getExperiments(url) {
        let http = new AbTestHttpService();
        return http
            .setDefaultXhrUrl(url)
            .getVariantForExperiments()
            .then((res) => {
                return res;
            })
            .catch((err) => {
                throw new Error(err);
            });
    }
}

//
// ui template vars
//

const MODAL_DIVIDER = `<div class="horizontal__divider"></div>`;

const MODAL_LOADER = `
<div class="ui-tool spinner-area">
    <div class="spinner"></div>
    <h2>Gathering experiment data....</h2>
</div>`;

const MODAL_LEGEND = `
    <fieldset>
        <legend>
            Legend
        </legend>
        <button class="button">
            <div class="button__text">
                Selected Variant
            </div>
        </button>
        <button class="button secondary">
            <div class="button__text">
                Available Variant
            </div>
        </button>
    </fieldset>
`;

// keep container empty
const MODAL_MESSAGE = `
    <div class="abtest__modal__message">
    </div>
`;

const CONTROL_BAR = `
    <div class='control__bar'>
        <div class="button__close">
        </div>
    </div>
`;

const MODAL_TITLE = `
    <div class="modal__title">
        A/B Tests Running on This Page
    </div>
`;

const MODAL_AB_TEST_LIST = `
    <div class="abtest__list__container">
        <ul id="abtest__list"></ul>
    </div>
`;

const MODAL_BOTTOM = `
    <div class="modal__buttons">
        <button id="modal__close__button" class="button button__close">
            <div class="button__text">
                Close
            </div>
        </button>
        <a class="button" href="${getDashbarodUrl()}" target="_blank">
            <div class="button__text">
                View All
            </div>
        </a>
    </div>
`;

const AB_EXPERIMENTS_MODAL_TEMPLATE = `
    <div class="modal__container abtest__framework">
        <div class="modal__wrapper">
            ${CONTROL_BAR}
            ${MODAL_TITLE}
            ${MODAL_DIVIDER}
            ${MODAL_LEGEND}
            ${MODAL_DIVIDER}
            ${MODAL_MESSAGE}
            ${MODAL_LOADER}
            ${MODAL_AB_TEST_LIST}
            ${MODAL_BOTTOM}
        </div>
    </div>
`;
